import React, { useMemo } from "react";
import { Route, Redirect } from "react-router-dom";

import WorkflowSearch from "../pages/executions/WorkflowSearch";
import TaskSearch from "../pages/executions/TaskSearch";

import Execution from "../pages/execution/Execution";
import WorkflowDefinitions from "../pages/definitions/Workflow";
import WorkflowDefinition from "../pages/definition/WorkflowDefinition";
import TaskDefinitions from "../pages/definitions/Task";
import TaskDefinition from "../pages/definition/TaskDefinition";
import EventHandlerDefinitions from "../pages/definitions/EventHandler";
import EventHandlerDefinition from "../pages/definition/EventHandler";
import TaskQueue from "../pages/misc/TaskQueue";
import KitchenSink from "../pages/kitchensink/KitchenSink";
import DiagramTest from "../pages/kitchensink/DiagramTest";
import Examples from "../pages/kitchensink/Examples";
import Gantt from "../pages/kitchensink/Gantt";

import Workbench from "../pages/workbench/Workbench";
import Admin from "../pages/admin-screen/Admin";

const ProtectedRoute = React.memo(
  ({ component: Component, permissions, path, ...rest }) => {
    const hasAccess =
      permissions?.active === "True" && permissions?.hide === "False";

    return (
      <Route
        {...rest}
        render={(props) =>
          hasAccess ? (
            <Component {...props} permissions={permissions} />
          ) : (
            <Redirect
              to={{
                pathname: "/no-access",
                state: { from: props.location },
              }}
            />
          )
        }
      />
    );
  }
);

export default ProtectedRoute;

export const ROUTE_CONFIG = [
  {
    path: "/search",
    key: "search",
    component: WorkflowSearch,
    tabType: "Execution",
  },
  {
    path: "/search/tasks",
    key: "search-tasks",
    component: TaskSearch,
    tabType: "Execution",
  },
  {
    path: "/execution/:id/:taskId?",
    key: "execution",
    component: Execution,
    tabType: "Execution",
  },
  {
    path: "/workflowDefs",
    key: "workflowDefs",
    component: WorkflowDefinitions,
    tabType: "Definition",
  },
  {
    path: "/workflowDef/:name?/:version?",
    key: "WorkflowDefinition",
    component: WorkflowDefinition,
    tabType: "Definition",
  },
  {
    path: "/taskDefs",
    key: "taskDefs",
    component: TaskDefinitions,
    tabType: "Definition",
  },
  {
    path: "/taskDef/:name?",
    key: "taskDef",
    component: TaskDefinition,
    tabType: "Definition.tasks",
  },
  {
    path: "/eventHandlerDef",
    key: "eventHandlerDef",
    component: EventHandlerDefinitions,
    tabType: "Definition",
  },
  {
    path: "/eventHandlerDef/:name",
    key: "eventHandlerDefinition",
    component: EventHandlerDefinition,
    tabType: "Definition",
  },
  {
    path: "/taskQueue/:name?",
    key: "taskQueue",
    component: TaskQueue,
    tabType: "Task Queues",
  },
  {
    path: "/workbench",
    key: "workbench",
    component: Workbench,
    tabType: "Workbench",
  },
  {
    path: "/workbench/:name?/:version?",
    key: "workbench-detail",
    component: Workbench,
    tabType: "Workbench",
  },
  {
    path: "/admin",
    key: "admin",
    component: Admin,
    tabType: "Admin",
  },
];

export const KITCHEN_ROUTES = [
  { path: "/kitchen", key: "kitchen", component: KitchenSink },
  { path: "/kitchen/diagram", key: "kitchen-diagram", component: DiagramTest },
  { path: "/kitchen/examples", key: "kitchen-examples", component: Examples },
  { path: "/kitchen/gantt", key: "kitchen-gantt", component: Gantt },
];
